import { createSlice } from '@reduxjs/toolkit';

import { handleGetRiskLevels } from './actions';
import { IRiskLevelsState } from './slice.interface';

const initialState: IRiskLevelsState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const riskLevelsSlice = createSlice({
  name: 'risk-levels',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleGetRiskLevels.pending, (state: IRiskLevelsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetRiskLevels.rejected, (state: IRiskLevelsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetRiskLevels.fulfilled, (state: IRiskLevelsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export default riskLevelsSlice.reducer;
